import Vue from "vue";

export default function calcFontSize() {
  // const w = document.body.clientWidth
  const w = document.getElementById("app").clientWidth;
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    Vue.prototype._global_navigator = "mobile";
    document.documentElement.style.fontSize = 18 * (w / 2560) + "px";
  } else {
    Vue.prototype._global_navigator = "pc";
    document.documentElement.style.fontSize = 12 * (w / 2560) + "px";
  }
}



// WEBPACK FOOTER //
// ./src/js/responsive_layout.js